import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISingleIdParams } from '../../../ts/ServerApi/types/actionParams';
import { IDatasourceActions } from '../types/IDatasourceActions';

export class GetDatasourceActionsRequest extends Request<ISingleIdParams, IDatasourceActions> {
  constructor(id: string) {
    super('getDatasourceActions', { id: id });
  }
}
